<template>
  <div class="c-login__wrapper">
    <div class="c-login__content">
      <figure class="c-login__figure" alt="D-bok logo">
        <d-bok-logo class="c-login__logo"></d-bok-logo>
      </figure>

      <div class="c-login__text">
        <h1 class="c-login__heading">
          {{ $t('LOGIN_WELCOME_HEADING') }}
        </h1>

        <p class="c-login__paragraph">
          {{ $t('LOGIN_WELCOME_PARAGRAPH') }}
        </p>

        <ul class="c-login__list">
          <li class="c-login__list-item">
            {{ $t('LOGIN_WELCOME_LIST1')}}
          </li>

          <li class="c-login__list-item">
            {{ $t('LOGIN_WELCOME_LIST2')}}
          </li>
        </ul>

        <div class="c-login__info">
          <span class="c-login__info-icon">
            <help-icon />
          </span>
          <p class="c-login__info-text">
            {{ $t('LOGIN_WELCOME_INFO1') }}<br>
            <span v-html="$t('LOGIN_WELCOME_INFO2')"></span>
          </p>
        </div>
      </div>

      <div class="c-login__btn-wrapper">
        <button class="c-login__btn" @click="login">{{ $t('LOGIN_BUTTON') }}</button>
      </div>
    </div>
    <div class="c-login__image">
      <div class="c-login__image-wrapper">
        <img
          class="c-login__image-image"
          srcset="
            /img/onboarding/onboarding.jpg,
            /img/onboarding/onboarding@2x.jpg 2x,
            /img/onboarding/onboarding@3x.jpg 3x
          "
          src="/img/onboarding/onboarding@3x.jpg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import auth from '@/auth/auth'
import dbokLogo from '@/assets/svg/DbokLogo'
import HelpIcon from '@/assets/svg/HelpIcon'

import { setDocumentTitle } from '@/utils/utils'

export default {
  name: 'login',

  components: {
    'd-bok-logo': dbokLogo,
    'help-icon': HelpIcon
  },

  async created () {
    setDocumentTitle(this.$t('LOGIN_WELCOME'))

    try {
      await this.checkToken()
      this.$router.push('/library')
    }
    catch (err) {
      // not logged in
    }
  },

  watch: {
    ['$i18n.locale']() {
      setDocumentTitle(this.$t('LOGIN_WELCOME'))
    }
  },

  methods: {
    login () {
      auth.authorize({
        redirectUrl: localStorage.getItem('unAuthLastViewedURL') || window.location
      })
    },

    ...mapActions({
      checkToken: 'user/checkToken'
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-login__wrapper {
  position: relative;
  display: block;
  min-height: 100vh;
  padding: 2rem 0;
  background-color: $dark-blue;

  @media (min-width: 768px) {
    display: flex;
    padding: 0;
    background-color: transparent;
  }
}

.c-login__text {
  color: $white;
  font-weight: 500;
  font-size: 1rem;

  padding: 0 2rem;

  margin-bottom: 4rem;
}

.c-login__heading {
  font-size: 2.5rem;
  font-weight: 700;
  color: $very-light-pink;
}

.c-login__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $dark-blue;

  @media (min-width: 768px) {
    width: 60%;
  }
}

.c-login__image {
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40%;
    text-align: center;
  }
}

.c-login__paragraph {
  font-size: 1.2rem;
  margin-top: 1.2rem;
}

.c-login__list-item {
  position: relative;
  padding-left: 45px;
  margin-top: 1.5rem;

  &::after {
    content: '';
    position: absolute;
    left: 10px;
    top: 4px;
    width: 10px;
    height: 16px;
    border: solid $white;
    border-width:0 3px 3px 0;
    transform: rotate(45deg);
  }
}

.c-login__info {
  display: flex;
  margin-top: 2.5rem;

  @media (min-width: 768px) {
    margin-top: 8rem;
  }

  a {
    color: $very-light-pink;
    text-decoration: underline;

    &:hover {
      color: $white;
    }
  }
}

.c-login__info-text {
  line-height: 1.25;
}

.c-login__info-icon {
  margin-right: 0.5rem;
  padding-top: 0.25rem;
}

.c-login__figure {
  margin: 0 auto 3rem;
}

.c-login__logo {
  width: 187px;
  height: 55px;
}

.c-login__btn {
  @include btn();
  background-color: $orange;
  color: $white;
  border-color: $orange;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -0.5px;
  text-align: center;
  padding: 0.65rem 3rem;
  margin: 0 auto;

  &:hover {
    background-color: $orange-hover;
    border-color: $orange-hover;
  }

  @include edge {
    font-weight: bold;
  }
  @include a11yOutline();
}
</style>
